import React, { createContext, useContext, useMemo } from 'react';

const Context = createContext();

export const useRenderProps = () => useContext(Context);

export const RenderPropsProvider = ({ children, renderActions }) => {
  const value = useMemo(() => ({ renderActions }), [renderActions]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
